<template>
  <div class="inmuebles-grid">
    <DxDataGrid
      v-bind="getDefaultGridProperties()"
      :data-source="gridSource"
      :show-borders="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :selected-row-keys="modelValue ? [modelValue] : []"
      @selection-changed="onSelectionChanged"
      @row-click="onRowClick"
    >
    
      <DxColumn data-field="Tipo" :caption="$t('inmuebles.grid.tipo')" cell-template="tipoTemplate">
        <DxLookup v-bind="{ ...getLookup('inmuebles', 'tipo') }"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Direccion" :caption="$t('inmuebles.grid.direccion')"></DxColumn>
      <DxColumn data-field="Municipio" :caption="$t('inmuebles.grid.localidad')"></DxColumn>
      
      <template #tipoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2`,
          `tipologia ${data.value.replace(' ', '')}`,
        ]">
          {{ $t(`inmuebles.tipo.${data.value}`) }}
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from '@api/integration';
import type { DXLoadOptions } from '@api/api';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DxLookup } from 'devextreme-vue';
import { onMounted, ref, watch } from 'vue';
import type CustomStore from 'devextreme/data/custom_store';
import { getDefaultGridProperties, getLookup } from '@helpers/grid-helper';

const api = useApi();
const gridSource = ref<CustomStore>();
const isInitializing = ref(true);

const props = defineProps<{
  modelValue?: string,
  idClienteInmobiliario?: string
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'inmueble-selected', inmueble: any): void
}>();

onMounted(async () => {
  await setDataSource();
  isInitializing.value = false;
});

const setDataSource = async () => {
  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;
      return await api.callStandardApi("getInmueblesForGrid", { showLoading: false }, q, props.idClienteInmobiliario);
    }
  });
}

const onSelectionChanged = (e: any) => {
  if ((isInitializing.value || !e.event) && e.selectedRowKeys.length === 0) {
    return;
  }

  if (e.selectedRowKeys.length > 0) {
    emit('inmueble-selected', e.selectedRowsData[0]);
  } else {
    emit('inmueble-selected', null);
  }
};

const onRowClick = (e: any) => {
  emit('inmueble-selected', e.data);
};

</script>

<style lang="scss" scoped>


.inmuebles-grid {
  height: 400px;
  width: 100%;
}

:deep(.dx-row.dx-data-row.dx-row-selected:hover) {
  background-color: red !important;
  cursor: pointer;
}

:deep(.dx-row.dx-data-row:hover) {
  background-color: var(--grid-alt-row-background) !important;
  cursor: pointer;
}

</style> 